import * as yup from "yup";
let createRunsheetValidationForm = yup.object().shape({
  driver: yup.string().required("Driver is required"),
  destination_branch: yup.string().required("Branch is required"),
});
let createReturnOrderValidationFrom = yup.object().shape({
  driver: yup.string().required("Driver is required"),
  merchant: yup.string().required("Vendor is required"),
});
let createRtvBranchValidationForm = yup.object().shape({
  destination_branch: yup.string().required("Branch is required"),
});

let vehicleValidationForm = yup.object().shape({
  emergency_contact_number: yup
    .string()
    .required("Emergency Contact Number is required"),
  license_number: yup.string().required("License Number is required"),
});
let createRiderValidationForm = yup.object().shape({
  full_name: yup.string().required("Full Name is required"),
  mobile_number: yup.string().required("Mobile Number is required"),
  license_number: yup.string().required("License Number is required"),
  branch: yup.string().required("Branch is required"),
});

export {
  createRunsheetValidationForm,
  vehicleValidationForm,
  createRiderValidationForm,
  createReturnOrderValidationFrom,
  createRtvBranchValidationForm,
};
